// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-tab-active":"Jae5w","empty":"OXsHr","message":"DboXL","content":"JVzwh"};